<template>
	<v-app>
		<v-main class="login">
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="px-5 rounded-xl elevation-0">
							<v-card-text class="pa-sm-5">
								<div class="pb-3 text-center">
									<div class="pt-5 pb-3 d-flex justify-center">
										<div class="login-icon"></div>
									</div>
									<div class="font-size-14 font-weight-500 primary--text">Masuk ke Akun Anda</div>
								</div>
								<v-form ref="formLogin" role="form" v-on:submit.prevent="onLogin">
									<v-alert dense dark v-if="errorMessage.length > 1" color="warning" class="rounded-xl">{{ errorMessage }}</v-alert>
									<v-text-field color="primary" placeholder="No Handphone/Username" ref="username" prepend-icon="mdi-account" type="text" v-model="username" tabindex="1" :rules="usernameRules"></v-text-field>
									<v-text-field color="primary" placeholder="Password" ref="password" id="password" prepend-icon="mdi-lock" type="password" v-model="password" tabindex="3" :append-icon="iconPass" @click:append="showPassword" :rules="passwordRules"></v-text-field>
									<div id="captcha-div"></div>
									<v-text-field color="primary" placeholder="Kode Unik" ref="kodeunik" id="uniqueKey" prepend-icon="mdi-qrcode" type="text" v-model="kodeunik" tabindex="4" append-icon="mdi-reload" @click:append="createCaptcha" :rules="kodeunikRules" validate-on-blur></v-text-field>
									<v-layout column align-center class="pt-5 pb-3">
										<v-flex>
											<v-btn large depressed dark color="primary" class="rounded-xl" :loading="btnLoading" tabindex="5" type="submit">
												<v-icon>mdi-login-variant</v-icon>
												<span class="pl-2">Masuk</span>
											</v-btn>
										</v-flex>
									</v-layout>
								</v-form>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<v-footer padless class="bg-light-primary">
			<v-col class="text-center primary--text" cols="12">
				2022 - <strong>Swarna</strong>
			</v-col>
		</v-footer>
	</v-app>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
	components: {
		
	},
	data() {
		return {
			code: null,
			btnLoading: false,
			username: '',
			password: '',
			// username: 'MAB1000369',
			// password: 'admin',
			kodeunik: '',
			iconPass: 'mdi-eye',
			usernameRules: [
			v => !!v || 'Username tidak boleh kosong',
			],
			phonenumberRules: [
			v => !!v || 'Nomor Telepon tidak boleh kosong',
			],
			passwordRules: [
			v => !!v || 'Password tidak boleh kosong',
			],
			kodeunikRules: [
			v => !!v || 'Kode Unik tidak boleh kosong',
			v => v === this.code || 'Kode Unik Salah. Coba kembali'
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('autentikasi', ['isAttempting']),
		...mapState(['errorMessage']),
	},
	methods: {
		...mapActions('autentikasi', ['login']),
		...mapMutations(['emptyErrorMessage']),

		async onLogin() {
			if (this.$refs.formLogin.validate()) {
				this.btnLoading = await true
				await this.login({ username: this.username, password: this.password }).then(() => {
					const { redirect } = this.$route.query;

					setTimeout(() => {
						if (redirect) {
							this.btnLoading = false
							this.$router.push(redirect);
							this.emptyErrorMessage()
						} else {
							this.btnLoading = false
							this.$router.push({ name: "dashboard" })
							this.emptyErrorMessage()
						}
					}, 1000);
				}).catch(() => {
					this.btnLoading = false
				})
			} else {
				if (!this.kodeunik) {
					setTimeout(() => {
						this.$refs.kodeunik.focus()
					}, 200);
				}

				if (!this.password) {
					setTimeout(() => {
						this.$refs.password.focus()
					}, 200);
				}

				if (!this.username) {
					setTimeout(() => {
						this.$refs.username.focus()
					}, 200);
				}
			}
		},
		showPassword() {
			var x = document.getElementById("password");
			if (x.type === "password") {
				x.type = "text"
				this.sPassword = true
				this.iconPass = 'mdi-eye-off'
			} else {
				x.type = "password"
				this.sPassword = false
				this.iconPass = 'mdi-eye'
			}
		},
		async createCaptcha() {
			const canvas = await document.getElementById('captcha-div')
			if (canvas.children.length > 0) canvas.innerHTML= await ''
				this.kodeunik = await ''

			// const charsArray = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
			const charsArray = 'ABCDEFGHKLMNPRSTUVWYZ23456789'
			const lengthOtp = 6
			let captcha = []

			for (let i = 0; i < lengthOtp; i++) {
				/*below code will not allow Repetition of Characters*/
				/*get the next character from the array*/
				let index = Math.floor(Math.random() * charsArray.length + 1)
				if (captcha.indexOf(charsArray[index]) == -1)
					captcha.push(charsArray[index])
				else i--
			}

			const canv = document.createElement('canvas')
			canv.id = 'captcha'
			canv.width = 180
			canv.height = 45
			/*canv.dir = 'ltr'*/

			let ctx = canv.getContext('2d')
			ctx.textBaseline = 'middle';
			ctx.textAlign = 'center'
			ctx.font = 'normal bold 32px serif'
			ctx.fillText(captcha.join(''), 90, 25)

			/*storing captcha so that can validate you can save it somewhere else according to your specific requirements*/
			this.code = captcha.join('')
			document.getElementById("captcha-div").appendChild(canv);
			// this.kodeunik = captcha.join('')
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Login Virtual Office`)
		this.createCaptcha()
	}
};
</script>